module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"monthly":"/Monat","subscription":"Abonnement"},"en":{"monthly":"/month","subscription":"subscription"},"es":{"monthly":"/mes","subscription":"Suscripción"},"fr":{"monthly":"/mois","subscription":"Abonnement"},"it":{"monthly":"/mese","subscription":"Abbonamento"},"ja":{"monthly":"/月","subscription":"サブスクリプション"},"pt":{"monthly":"/ mês","subscription":"assinatura"}}')
  delete Component.options._Ctor
}
